import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AuthService } from '../../services/auth/auth.service';
import { TYPE_USER_ENUM } from 'src/app/shared/enums/type-user.enum';

/**
 * Restringe a rota aos tipos de usuário listados em `route.data['profileList']`
 * (um array de `TYPE_USER_ENUM`, como definido nos arquivos de rotas).
 */
export const profileGuard: CanActivateFn = (route): boolean | UrlTree => {
  const profileList = (route.data['profileList'] ?? []) as TYPE_USER_ENUM[];
  const userType = inject(AuthService).getTokenDetails()?.user?.type;

  if (userType && profileList.includes(userType)) {
    return true;
  }

  return inject(Router).parseUrl('/home');
};
